(function(angular){
    'use strict';

    angular.module('onvio.setup.client.notifications').factory('onvio.setup.client.notifications.WordingCategory', wordingCategory);
    wordingCategory.$inject = [];

    function wordingCategory(){
        function WordingCategory(data){
            var self = this;

            // properties
            updateData(data);

            //////////

            function updateData(category){
                angular.extend(self, category);
                // self.id = category.id;
                // self.code = category.code;
                // self.names = angular.isUndefined(category.names) ? [] : category.names;
                // self.types = angular.isUndefined(category.types) ? [] : category.types;
            }
        }

        return WordingCategory;
    }
})(window.angular);
